import React from "react"
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap"
import { useEffect, useState } from "react"
import { setBreadcrumbItems } from "../../store/actions"
import { connect } from "react-redux"
import { MDBTable, MDBTableBody } from 'mdb-react-ui-kit';
import './table.css'
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { ApiNames } from "components/Common/ApiManagement/apiServices";
import { TableHeader } from "components/Common/common";
import { useLocation, useParams } from "react-router-dom";
import { MDBDataTable } from "mdbreact"
import DataTableWithPopup from "components/longContentTable"
import { PAGEPATHS } from "components/Common/Constant"

const SiteUrlSummary = (props) => {
     const { scanId } = useParams();
    const [pageData, setPageData] = useState([])
    const [outboundLinkData, setOutboundLinkData] = useState({})
    // const [scanId, setScanId] = useState(sessionStorage.getItem('scanId'))
    const [thirdPartyData, setThirdPartyData] = useState({
        columns: [
            {
                label: "Number of External Domains",
                field: "Number of External Domains",
                sort: "asc",
                width: 150,
            },
            {
                label: "External Domains",
                field: "External Domains",
                sort: "asc",
                width: 270,
            },
            {
                label: "External URLs",
                field: "External URLs",
                sort: "asc",
                width: 200,
            },
            {
                label: "Nearby Domains",
                field: "Nearby Domains",
                sort: "asc",
                width: 100,
            },
            {
                label: "Nearby URLs",
                field: "Nearby URLs",
                sort: "asc",
                width: 100,
            },
            {
                label: "Known Services",
                field: "Known Services",
                sort: "asc",
                width: 100,
            },
            {
                label: "Unknown Services",
                field: "Unknown Services",
                sort: "asc",
                width: 150,
            },
            {
                label: "URLs on the page",
                field: "URLs on the page",
                sort: "asc",
                width: 150,
            },
            {
                label: "Domains in the URLs on the page",
                field: "Domains in the URLs on the page",
                sort: "asc",
                width: 150,
            }
        ],
        rows: []
    })

    const breadcrumbItems = [
        { title: "Scan List", link: PAGEPATHS.Scanlist },
        { title: sessionStorage.getItem('domain'), link: "#" },
        { title: "Site URL Summary", link: "#" }
    ]

    useEffect(() => {
        props.setBreadcrumbItems("Site URL Summary", breadcrumbItems)
    })

    const getTheadName = (key) => {
        const values = {
            "Base_data_response_code": 'Base Data',
            "code.json_response_code": "Code.json",
            "coronavirus_response_code": "Corona Virus",
            "data.json_response_code": "data.json",
            "data_response_code": "data",
            "developer_response_code": "Developer",
            "digitalstrategy_response_code": "Digital Strategy",
            "open_response_code": "Open",
            "privacy_response_code": "Privacy",
            "robots.txt_response_code": "robots.txt",
            "sitemap.xml_response_code": "sitemap.xml",
            "cj_response_code": "Cj",
            "digitalstrategy_datacenteroptimizationstrategicplan.json_response_code": "DS_datacenteroptimizationstrategicplan.json",
            "digitalstrategy_FITARAmilestones.json_response_code": "DS_FITARAmilestones.json",
            "digitalstrategy_governanceboards.json_response_code": "DS_governanceboards.json",
            "digitalstrategy_costsavings.json_response_code": "DS_costsavings.json",
            "digitalstrategy_bureaudirectory.json_response_code": "DS_bureaudirectory.json",
            "redirecttest-foo-bar-baz_response_code": "redirecttest-foo-bar-baz"
        }
        return values[key]
    }

    useEffect(() => {
        const fetchPageDataScan = async () => {
            try {
                const { data } = await axiosInstance.get(`${ApiNames.FETCH_PAGE_DATA_SCAN}/${scanId}`)
                const entries = Object.entries(data.data).filter(([key, value]) => {
                    return value == 200 || value == 404;
                });
                setPageData(entries)
            } catch (e) {
                console.error(e);
            }
        }
        fetchPageDataScan()
    }, [scanId])

    useEffect(() => {
        const fetchOutboundScan = async () => {
            try {
                const { data } = await axiosInstance.get(`${ApiNames.FETCH_OUTBOUND_LINK_SCAN}/${scanId}`)
                setOutboundLinkData(data.data)
            } catch (e) {
                console.error(e);
            }
        }
        fetchOutboundScan()
    }, [scanId])


    useEffect(() => {
        const fetchThirdParty = async () => {
            try {
                const { data } = await axiosInstance.get(`${ApiNames.FETCH_THIRD_PARTY_SCAN}/${scanId}`)
                setThirdPartyData((prev) => ({
                    ...prev,
                    columns: prev.columns,
                    rows: [data.data]
                }))
            } catch (e) {
                console.error(e);
            }
        }
        fetchThirdParty()
    }, [scanId])

    return (
        <>
            <h3>Page Data</h3>
            {/* <MDBTable className="page-data-table" style={{ borderCollapse: 'collapse' }} borderless>
                <MDBTableBody> */}
            {/* <div className="page-data-table">
                {pageData.length !== 0 && pageData.map((chunk, index) => (
                    <div className="" key={index}>
                        <tr>
                            {chunk.map(([key]) => (
                                <th key={key}>{getTheadName(key)}</th>
                            ))}
                        </tr>
                        <tr style={{ borderBottom: '1em solid rgb(235 235 235)' }}>
                            {chunk.map(([key, value]) => (
                                <td key={key}>
                                    <span className={`${value == '200' ? 'badge-success' : 'badge-failure'}`}>
                                        {value == '200' ? 'Yes' : 'No'}
                                    </span>
                                </td>
                            ))}
                        </tr>
                    </div>
                ))}
            </div> */}
            <div className="d-flex flex-wrap">
                {pageData && pageData.length > 0 &&
                    pageData.map((item, index) => (
                        <div
                            key={index}
                            className="p-2"
                            style={{ flex: '0 0 20%', maxWidth: '20%' }}
                        >
                            <div className="border p-3 text-center">
                                <span className="d-block fw-bold text-wrap text-break">{getTheadName(item[0])}</span>
                                <span
                                    className={`d-block fs-4 mt-2 badge ${item[1] === '200' ? 'bg-success' : 'bg-danger'
                                        }`}
                                >
                                    {item[1] === '200' ? 'Yes' : 'No'}
                                </span>
                            </div>
                        </div>
                    ))}
            </div>
            {/* </MDBTableBody>
            </MDBTable> */}
            <Card className="outbound-container">
                <div className="base-domain">
                    <label htmlFor="base-domain">Base Domain:</label>
                    <h2 name="base-domain">{outboundLinkData['Base Domain']}</h2>
                </div>
                <div className="external-links">
                    <div>
                        <h4>External Links</h4>
                    </div>
                    <div>
                        {Object.keys(outboundLinkData).length !== 0 && outboundLinkData['External Links'].split(';').map((link, key) => (
                            <span key={key}>{link}</span>
                        ))}
                    </div>
                </div>
            </Card>
            <Card className="third-party-scan-container">
                <TableHeader scanName={'Third Parties'} scanId={scanId} />
                <CardBody>
                    <DataTableWithPopup noBottomColumns thirdPartyData={thirdPartyData} />
                </CardBody>
            </Card>
        </>
    )
}

export default connect(null, { setBreadcrumbItems })(SiteUrlSummary)
